<!--
 * @Description:
 * @Author: xz
 * @Date: 2023-10-20 16:41:10
 * @LastEditTime: 2023-11-14 14:33:51
 * @LastEditors: xz
-->
<!--疫情球体-->
<template>
  <div id="container">
    <!-- <button @click="sendToken">11111</button> -->
    <!-- <iframe id="iframeContainer" src="https://edam.tscon.cn:7778/earthgo/reactflow/" style="width: 100%; height: 100%" frameborder="0"/> -->
   <iframe id="iframeContainer" src="http://localhost:3000/" style="width: 100%; height: 100%" frameborder="0"/>
  </div>
</template>
<script>
  export default {
    data() {
      return {

      }
    },
    mounted() {
      window.addEventListener('message', (e) => {
        if (e.data.type == 'zhiShiTuPu') {
          let routerData = this.$router.resolve({ path: e.data.data});
          window.open(routerData.href,"_blank");
        }
      }, false)
      this.sendToken()
    },
    methods:{
      sendToken(){
        let iframe =  document.getElementById("iframeContainer")
        iframe.onload=(()=>{
          let send = document.getElementById("iframeContainer").contentWindow;
          send.postMessage(sessionStorage.getItem("token"),"*");
        })
      }
    }
  }
</script>
<style scoped>
#container {
  width: 100%;
  height: 100%;
  /* margin-top: 30px; */
  overflow-y: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/rebort.vue